<template>
  <v-expansion-panel>
    <v-expansion-panel-header
      :color="colors.text"
      ripple
    >
      <template #default="{ open }">
        <v-row
          align="center"
          class="spacer"
          no-gutters
        >
          <v-col cols="auto">
            <v-chip
              v-if="invalid"
              class="ml-0 mr-4 red"
              color="red"
              small
              outlined
            >
              <v-icon size="small">
                priority_high
              </v-icon>
            </v-chip>
            <v-chip
              v-else
              class="ml-0 mr-4 black--text"
              :color="colors.base"
              :text-color="open ? 'white' : colors.text"
              :outlined="!open"
              small
            >
              {{ chapter }}
            </v-chip>
          </v-col>

          <v-col>
            <strong :class="{ 'red--text': invalid }">{{ title }}</strong>
          </v-col>
        </v-row>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content
      class="pt-4"
      eager
    >
      <v-alert
        v-if="invalid"
        type="warning"
        text
        dense
        color="red"
      >
        Tarkista kentät
      </v-alert>
      <slot/>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
export default {
  props: {
    chapter: {
      type: String,
      default: () => null,
    },
    title: {
      type: String,
      default: () => null,
    },
    invalid: {
      type: Boolean,
      default: () => null,
    },
  },
  data: () => ({
    colors: {
      base: 'primary',
      text: 'primary--text',
    },
  }),
};
</script>
